var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailSend1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-750.000000, -842.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(112.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-3",
    transform: "translate(600.000000, 418.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(30.000000, 259.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email-send-1",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.146332092,4.62873529 C0.056827997,4.66658824 -0.000947133284,4.75636765 3.41740525e-16,4.85585294 C0.000947133284,4.95436765 0.0606165302,5.04317647 0.151067759,5.07860294 L4.08261802,6.64561765 L10.9630678,0.0504705882 L0.146332092,4.62873529 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26683544,7.13382353 L4.26209978,7.12897059 L4.26209978,10.4338235 C4.26209978,10.5667941 4.366758,10.6764706 4.4988831,10.6764706 C4.58128369,10.6764706 4.66036932,10.6318235 4.70346389,10.5561176 L6.26007744,7.821 L9.12041996,9.43314706 C9.18766642,9.47148529 9.26769918,9.47245588 9.33257781,9.44139706 C9.40077141,9.40985294 9.45002234,9.34725 9.46565004,9.27202941 L11.3494981,0.344558824 L4.26683544,7.13382353 Z",
    id: "Shape"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSend1);
export default __webpack_public_path__ + "static/media/email-send-1.e034246d42380a923791fe9e2b6dbb02.svg";
export { ForwardRef as ReactComponent };